import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiArrowRight, FiCheck } from 'react-icons/fi';
import Badge from '../../components/ui/Badge';
import Button from '../../components/ui/Button';
import SafeIcon from '../../common/SafeIcon';

const HeroSection = ({ onOpenCalendly }) => {
  const [showCTA, setShowCTA] = useState(false);

  useEffect(() => {
    // Timer für 15 Sekunden
    const timer = setTimeout(() => {
      setShowCTA(true);
    }, 15000);

    // Scroll-Listener als Fallback
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setShowCTA(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <section className="w-full max-w-6xl mx-auto px-4 sm:px-6 pt-16 md:pt-32 pb-24 md:pb-40 flex flex-col items-center text-center">
      <motion.div 
        initial={{ opacity: 0, y: 10 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 0.5 }}
        className="w-full flex justify-center"
      >
        <Badge className="mb-8 md:mb-12 py-2.5 px-4 md:px-6 border-brand-blue/30 bg-brand-blue/10">
          <span className="w-1.5 h-1.5 rounded-full bg-brand-blue flex-shrink-0 animate-pulse"></span>
          <span className="text-[10px] sm:text-xs md:text-sm font-medium leading-tight text-white whitespace-normal sm:whitespace-nowrap">
            Kostenlos für Software- und SaaS-Gründer im DACH-Raum
          </span>
        </Badge>
      </motion.div>

      <motion.h1 
        initial={{ opacity: 0, y: 15 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 0.5, delay: 0.1 }}
        className="text-[26px] sm:text-[36px] md:text-[44px] lg:text-[44px] font-bold tracking-tight text-white mb-6 md:mb-10 leading-[1.15] lg:leading-[1.2] max-w-4xl"
      >
        Du bist nicht Geschäftsführer deiner Firma.
        <br className="hidden md:block" /> Du bist ihr teuerster Mitarbeiter.
      </motion.h1>

      <motion.p 
        style={{ color: 'rgb(156, 163, 175)' }} 
        initial={{ opacity: 0, y: 15 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 0.5, delay: 0.2 }}
        className="text-base sm:text-lg md:text-[18px] text-gray-400 max-w-3xl mb-12 md:mb-16 leading-relaxed px-2"
      >
        Die meisten Software- und SaaS-Gründer haben ein Produkt gebaut, aber nie ihre Rolle als Geschäftsführer definiert.
        In diesem 5-Minuten-Video: die 4 Aufgaben, die nur du übernehmen kannst, damit deine Firma ohne dich läuft.
      </motion.p>

      <motion.div 
        initial={{ opacity: 0, scale: 0.98 }} 
        animate={{ opacity: 1, scale: 1 }} 
        transition={{ duration: 0.6, delay: 0.3 }}
        className="w-full max-w-4xl rounded-xl md:rounded-2xl border border-brand-border bg-brand-card/50 overflow-hidden shadow-[0_0_50px_rgba(47,107,255,0.1)] mb-16 md:mb-24 relative aspect-video"
      >
        <iframe 
          loading="eager" 
          title="Gumlet video player" 
          src="https://play.gumlet.io/embed/69fad1bf441ee3e92aa4be64?background=false&autoplay=false&loop=false&disable_player_controls=false" 
          className="absolute top-0 left-0 w-full h-full border-none"
          referrerPolicy="origin" 
          allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;fullscreen;clipboard-write;"
        ></iframe>
      </motion.div>

      <div className="min-h-[160px] w-full flex flex-col items-center">
        <AnimatePresence>
          {showCTA && (
            <motion.div 
              initial={{ opacity: 0, y: 20 }} 
              animate={{ opacity: 1, y: 0 }} 
              exit={{ opacity: 0, y: 20 }}
              className="w-full px-4 flex flex-col items-center"
            >
              <Button 
                onClick={onOpenCalendly} 
                className="w-full sm:w-auto text-base sm:text-lg px-10 md:px-14 py-4 md:py-6 mb-8"
              >
                Jetzt Termin vereinbaren <SafeIcon icon={FiArrowRight} />
              </Button>
              
              <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3 }}
                className="flex items-center gap-2.5 text-white font-medium text-sm sm:text-base opacity-90"
              >
                <div className="flex items-center justify-center w-5 h-5 rounded-full bg-white/10 border border-white/20">
                  <SafeIcon icon={FiCheck} className="text-[10px] text-white" />
                </div>
                <span>35M € Umsatz generiert und 150+ Kunden betreut</span>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};

export default HeroSection;